import { useEffect } from 'react';

/** Het voorvoegsel van de documenttitel op een trainingsomgeving (AC-A4.3). */
export const TRAINING_TITLE_PREFIX = '[Training] ';

/** De titel zonder voorvoegsel (idempotent: een titel zonder voorvoegsel blijft gelijk). */
export function stripTrainingPrefix(title: string): string {
    let out = title;
    while (out.startsWith(TRAINING_TITLE_PREFIX)) out = out.slice(TRAINING_TITLE_PREFIX.length);
    return out;
}

/** De titel met precies één voorvoegsel, ook als hij er al één (of meer) had. */
export function withTrainingPrefix(title: string): string {
    return TRAINING_TITLE_PREFIX + stripTrainingPrefix(title);
}

/**
 * Story `fe-be-cursusmodus-hersteller-mvp` (AC-A4.3, R-27) — zet `[Training] ` vóór de titel van
 * het tabblad zolang whoami een trainingsomgeving meldt (actief of geblokkeerd), en haalt het
 * weer weg als de vlag verdwijnt (uitloggen).
 *
 * Staat op APP-niveau (aangeroepen in `AuthProvider`), zodat het ook geldt op routes buiten de
 * `Chrome`. De balk zelf staat in de `Chrome`.
 *
 * - Nooit verdubbeld: de titel wordt eerst van een eventueel voorvoegsel ontdaan.
 * - Op productie (`isTraining === false` vanaf het begin) wordt `document.title` NIET geschreven:
 *   alleen gelezen, en alleen herschreven als er een voorvoegsel af moet.
 *
 * ⚠ Bewust in `src/auth/` en niet in `features/training/`: de `AuthProvider` zit in de keten van
 * `/monteur` (zie `trainingMode.ts`).
 *
 * @param isTraining uitkomst van `isTrainingEnvironment(user)`
 */
export function useTrainingDocumentTitle(isTraining: boolean): void {
    useEffect(() => {
        if (typeof document === 'undefined') return;
        const current = document.title;
        if (isTraining) {
            const next = withTrainingPrefix(current);
            if (next !== current) document.title = next;
            return;
        }
        if (current.startsWith(TRAINING_TITLE_PREFIX)) {
            document.title = stripTrainingPrefix(current);
        }
    }, [isTraining]);
}
